export default [
  'BrandResultList'
]

/*
Appears on:
/tires/brands
*/
